/* istanbul ignore file */
export function Finally() {
    Promise.prototype.finally = Promise.prototype.finally || {
        finally: function (fn) {
            var onFinally = function (value) { return Promise.resolve(fn()).then(function () { return value; }); };
            return this.then(function (result) { return onFinally(result); }, function (reason) { return onFinally(Promise.reject(reason)); });
        }
    }.finally;
}
//# sourceMappingURL=Finally.js.map